

<form [formGroup]="AddPersonAdmisionForm" (ngSubmit)="onSubmit()" class="row g-3  " >

  <div class="col-md-6">
    <label for="firstName" class="form-label">Primer Nombre</label>
    <input formControlName="firstName" type="text" minlength="1" maxlength="25" class="form-control inputGlobal" id="firstName" required>
    <div *ngIf="firstName?.invalid" class="invalidInput">
      Ingresa tu primer nombre
    </div>
  </div>
  <div class="col-md-6">
    <label for="secondName" class="form-label">Segundo Nombre</label>
    <input formControlName="secondName" type="text" minlength="1" maxlength="25" class="form-control inputGlobal" id="secondName" required>
    <div *ngIf="secondName?.invalid" class="invalidInput">
      Ingresa tu segundo nombre
    </div>
  </div>
  <div class="inputsHidden">
    <input formControlName="idPersona" type="hidden" id="idPersona">
  </div>

  <div class="col-md-6">
    <label for="firstApellido" class="form-label">Primer Apellido</label>
    <input formControlName="firstApellido" type="text" minlength="1" maxlength="25" class="form-control inputGlobal" id="firstApellido" required>
    <div *ngIf="firstApellido?.invalid" class="invalidInput">
      Ingresa tu primer apellido
    </div>
  </div>
  <div class="col-md-6">
    <label for="secondApellido" class="form-label">Segundo Apellido</label>
    <input formControlName="secondApellido" type="text" minlength="1" maxlength="25" class="form-control inputGlobal" id="secondApellido" required>
    <div *ngIf="secondApellido?.invalid" class="invalidInput">
      Ingresa tu segundo apellido
    </div>
  </div>
  <div class="col-md-12">
    <label for="inputEmail" class="form-label">Email</label>
    <input formControlName="inputEmail" type="email" class="form-control inputGlobal" id="inputEmail" placeholder="email@email.com" required>
    <div *ngIf="inputEmail?.invalid" class="invalidInput">
      Ingresa tu email
    </div>
  </div>
  <div class="col-md-4">
    <label for="inputPhone" class="form-label">Teléfono</label>
    <input formControlName="inputPhone" type="text" class="form-control inputGlobal" id="inputPhone" placeholder="09 999 9999" required>
    <div *ngIf="inputPhone?.invalid" class="invalidInput">
      Ingresa un numero de telefono valido
    </div>
  </div>
  <div class="col-md-4">
    <label for="fecha" class="form-label">Fecha Nacimiento</label>
    <input formControlName="fecha" type="date" class="form-control inputGlobal" id="fecha" required>
    <div *ngIf="fecha?.invalid" class="invalidInput">
      Ingresa una fecha valida
    </div>
  </div>
  <div class="col-md-4">
    <label for="inputSexo" class="form-label">Sexo</label>
    <select formControlName="inputSexo"  name="" id="inputSexo" class="form-control inputGlobal" required>
      <option value="" selected disabled>Seleccionar Sexo</option>
      <option *ngFor="let option of sexOptions" [value]="option.value">{{ option.name }}</option>
    </select>
    <div *ngIf="inputSexo?.invalid" class="invalidInput">
      Escoge uno

    </div>
  </div>
  <div class="col-12">
    <label for="inputAddress" class="form-label">Direccion</label>
    <input formControlName="inputAddress" type="text" class="form-control inputGlobal" id="inputAddress" placeholder="Av. Siempre Viva">
  </div>
  <div *ngIf="inputAddress?.invalid" class="invalidInput">
    Ingresa una dirección valida
  </div>
  <br>
  <div class="col-12">
<!--    <button type="submit" class="w-100 btn btn-outline-primary buttonAGlobal">Registrar Usuario y Generar Link de Pago</button>-->
    <button type="submit" class="w-100 btn  buttonAGlobal" [disabled]="!AddPersonAdmisionForm.valid" >Guardar y continuar</button>
  </div>
</form>


